import { render, staticRenderFns } from "./modaUsarCatalogo.vue?vue&type=template&id=2c614c3b&"
import script from "./modaUsarCatalogo.vue?vue&type=script&lang=js&"
export * from "./modaUsarCatalogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports